module.exports = function (data) {
var __t, __p = '';
__p += '\r\n<div class="title">\r\n        <img src="assets/Title.svg" alt="Stingy Jack\'s New Lantern" />\r\n</div>\r\n\r\n<button class="spider right" data-action="start">\r\n        <img src="./assets/Spider.svg" alt="next" />\r\n        <span class="label">Start</span>\r\n</button>\r\n\r\n\r\n<div class="web top-left"></div>\r\n<div class="web bottom-right"></div>';
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/views/Title.ejs
// module id = 8
// module chunks = 0